
import api from '@/utils/api'
const state = {
  user: {
  }
}
const getters = {
  getUser (state) {
    return state
  }
}

const actions = {
  setUser (contaxt, user) {
    contaxt.commit('SET_USER', user)
  },
  getLocation ({ commit }, payload) {
    return api('/api/lbs', 'POST', payload)
  },
  updateOrganization ({ commit }, payload) {
    return api('/api/organization', 'PUT', payload)
  },
  getQrcode ({ commit }, payload) {
    return api('/api/qrcode', 'GET', payload)
  },
  getOrganizations ({ commit }, payload) {
    return api('/api/organizations', 'GET', payload)
  },
  getExperts ({ commit }, payload) {
    return api('/api/experts', 'GET', payload)
  },
  getExpertsList ({ commit }, payload) {
    return api('/api/experts/list', 'GET', payload)
  },
  updateUserInfo ({ commit }, payload) {
    return api('/api/user', 'POST', payload)
  },
  getUsersByDoctorId ({ commit }, payload) {
    return api('/api/doctor/users', 'GET', payload)
  },
  getUserByDoctorId ({ commit }, payload) {
    return api('/api/doctor/user', 'GET', payload)
  },
  getUsersList ({ commit }, payload) {
    return api('/api/users', 'GET', payload)
  },
  getUserInfo ({ commit }, payload) {
    return api('/api/user', 'GET', payload)
  },
  addPatient ({ commit }, payload) {
    return api('/api/patient', 'POST', payload)
  },
  getPatients ({ commit }, payload) {
    return api('/api/patients', 'GET', payload)
  },
  getPatientById ({ commit }, payload) {
    return api('/api/patient', 'GET', payload)
  },
  sendSMS ({ commit }, payload) {
    return api('/api/sms/code', 'POST', payload)
  },
  sendMingyuSMS ({ commit }, payload) {
    return api('/api/sms/code/mingyu', 'POST', payload)
  },
  bindMobile ({ commit }, payload) {
    return api('/api/mobile', 'POST', payload)
  },
  uploadImage ({ commit }, payload) {
    return api('/api/image', 'POST', payload)
  },
  getUser ({ commit }, payload) {
    return api('/api/admin/user', 'GET', payload)
  }
}

const mutations = {
  SET_USER (state, { user }) {
    state.user = user
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
